/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Field, getIn } from 'formik';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
}));

export const RenderDateSelectField = ({
  field,
  form: { touched, errors, setFieldValue },
  onChangeChecker,
  doNotCheckValidity,
  fullWidth,
  ...others
}) => {
  const { classes } = useStyles();
  const touch = getIn(touched, field.name);
  const error = getIn(errors, field.name);

  return (
    <DatePicker
      format="DD/MM/YYYY"
      name={field.name}
      value={field.value}
      onChange={(date, value) => {
        if (doNotCheckValidity) {
          setFieldValue(field.name, date);
        } else {
          if (date?.isValid()) {
            setFieldValue(field.name, date);
          } else {
            setFieldValue(field.name, null);
          }
        }
      }}
      // KeyboardButtonProps={{
      //   'aria-label': 'change date',
      // }}
      // invalidLabel="Desconhecido"
      // invalidDateMessage="Formato inválido"
      // cancelLabel="Cancelar"
      // clearLabel="Limpar"
      // minDateMessage="Data não pode ser menor que a data mínima"
      // maxDateMessage="Data não pode ser maior que a data máxima"
      // InputLabelProps={{ shrink: true }}
      // error={touch && error != null}
      // helperText={touch && error}
      dayOfWeekFormatter={(dayAsString) => {
        return dayAsString;
      }}
      slotProps={{
        textField: {
          fullWidth: fullWidth,
          error: touch && error != null,
          helperText: touch && error,
          variant: 'standard',
          className: classes.formControl,
          InputLabelProps: { shrink: true },
        },
      }}
      {...others}
    />
  );
};

export const FormDateField = ({ name, ...others }) => {
  return <Field name={name} component={RenderDateSelectField} {...others} />;
};
